import { useEffect, useState } from 'react';
import { updateLog } from '@/mocks/russianMom';

const navItems = [
  { id: 'synopsis', label: '剧情简介' },
  { id: 'episodes', label: '分集看点' },
  { id: 'cast', label: '主要角色' },
  { id: 'stills', label: '精彩剧照' },
  { id: 'highlights', label: '观看理由' },
  { id: 'reviews', label: '观众短评' },
  { id: 'faq', label: '常见问题' },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <header className="w-full">
      {/* 更新条压顶 */}
      <div className="w-full bg-foreground-950 text-background-50">
        <div className="mx-auto flex max-w-[1280px] items-center gap-3 px-4 py-2 md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-2.5 py-0.5 text-xs font-medium text-background-50">
            <i className="ri-flashlight-fill text-[11px]" aria-hidden="true"></i>
            最新更新
          </span>
          <div className="flex flex-1 items-center gap-5 overflow-x-auto whitespace-nowrap text-xs text-background-300 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
            {updateLog.map((item) => (
              <span key={item.id} className="flex shrink-0 items-center gap-2">
                <span className="text-background-100">{item.season}</span>
                <span>{item.ep}</span>
                <span className="rounded-sm bg-background-50/10 px-1.5 py-0.5 text-[11px] text-accent-300">{item.tag}</span>
                <span className="text-background-400">{item.time}</span>
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* 导航 */}
      <nav className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex max-w-[1280px] items-center justify-between gap-4 px-4 py-3 md:px-6">
          <a href="#top" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-movie-2-line text-lg" aria-hidden="true"></i>
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-heading text-lg font-bold text-foreground-950">俄罗斯妈妈</span>
              <span className="text-[11px] text-foreground-500">中文字幕 · 高清剧集</span>
            </span>
          </a>

          <div className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-secondary-900"
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-2">
            <a
              href="#episodes"
              className="hidden shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:flex"
            >
              <i className="ri-play-circle-line" aria-hidden="true"></i>
              开始观看
            </a>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label="打开导航菜单"
              aria-expanded={open}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
            </button>
          </div>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
            <div className="grid grid-cols-2 gap-1">
              {navItems.map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-secondary-900"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}